var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.basalamProduct != null)?_c('div',{},[_c('div',{staticClass:"btn btn-warning rounded-pill"},[_vm._v("وضعیت: "+_vm._s(_vm.basalamProduct.status.title))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }